<div class="page-layout">
	<main class="min-w-0">
		<router-outlet></router-outlet>
	</main>
	<app-footer />
</div>
